// NotificationProvider.tsx
import React, { useEffect } from 'react';
import { notification } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { clearNotifications } from '../../redux/globalSlice.ts';
import { RootState } from '../../redux/store.ts';
import {
  CheckCircleFilled,
  CloseCircleFilled,
  ExclamationCircleFilled,
  InfoCircleFilled,
} from '@ant-design/icons';

// Icon mapping function
const getNotificationIcon = (type: string) => {
  switch (type) {
    case 'success':
      return <CheckCircleFilled style={{ color: '#4caf50' }} />;
    case 'error':
      return <CloseCircleFilled style={{ color: '#f44336' }} />;
    case 'warning':
      return <ExclamationCircleFilled style={{ color: '#ff9800' }} />;
    case 'info':
    default:
      return <InfoCircleFilled style={{ color: '#2196f3' }} />;
  }
};

const NotificationProvider: React.FC = () => {
  const notifications = useSelector((state: RootState) => state.global.notifications);
  const dispatch = useDispatch();
  const [api, contextHolder] = notification.useNotification();

  useEffect(() => {
    notifications.forEach((notif) => {
      api.open({
        key: notif.key || new Date().getTime(),
        message: notif.title,
        description: notif.description,
        icon: getNotificationIcon(notif.type), // Automatically set icon based on type
        className: notif.className || '',
        duration: notif.duration || 4.5,
      });
    });

    // Clear notifications after showing them
    if (notifications.length) {
      dispatch(clearNotifications());
    }
  }, [notifications, api, dispatch]);

  return <>{contextHolder}</>;
};

export default NotificationProvider;
